import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const AppointmentFormSlice = createSlice({
  name: "AppointmentFormReducer",
  initialState,
  reducers: {
    setAppointmentData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setAppointmentData, resetState } = AppointmentFormSlice.actions;

export default AppointmentFormSlice.reducer;
